import { Anchor, Breadcrumbs, Text } from '@mantine/core';

export interface BreadCrumb {
  title: string;
  href: string;
}
export default function BreadCrumbs({ items }: { items: BreadCrumb[] }) {
  const lastItem = items.length - 1;

  return (
    <Breadcrumbs pt={4}>
      {items.map((item, index) =>
        index === lastItem ? (
          <Text key={item.href} fz="sm" fw={500}>
            {item.title}
          </Text>
        ) : (
          <Anchor key={item.href} href={item.href} fz="sm" fw={500}>
            {item.title}
          </Anchor>
        )
      )}
    </Breadcrumbs>
  );
}
